export const putchClick = (id, navigate) => {

  navigate(`/product-rewrite/${id}`);

}